// Monto a cobrar contra entrega (COD).
//
// La regla la fija el DTO de microservice-packages, dueño del dato: número POSITIVO
// con máximo 2 decimales. Acá se replica sólo para avisar al comercio antes de enviar;
// la validación que manda sigue siendo la del backend.
//
// Se centraliza en un único módulo porque el mismo criterio se aplica en tres puntos
// del wizard (campo del paso "Paquete", armado del payload unitario y validación fila
// a fila del Excel): si divergen, el front acepta montos que el backend rechaza — o
// peor, descarta en silencio un monto que el comercio sí quería cobrar.

export const COD_AMOUNT_RULE =
  "Debe ser un número mayor a 0 con máximo 2 decimales (usa punto como separador decimal).";

// Formato aceptado: sólo dígitos y, opcionalmente, punto con 1-2 decimales.
// No se admite coma: "1.500,50" y "1,500.50" son ambiguos entre separador de miles y
// decimal, y adivinar mal cambia el monto que se le cobra al destinatario.
const AMOUNT_FORMAT = /^\d+(\.\d{1,2})?$/;

/**
 * Interpreta el valor crudo de un input o de una celda de Excel.
 * @returns {{status: "empty"|"invalid"|"ok", amount?: number}}
 *   - "empty":   no hay monto → el pedido va sin cobro (no se manda la clave).
 *   - "invalid": hay algo escrito pero no es un monto válido.
 *   - "ok":      `amount` es el número a enviar.
 */
export const parseCodAmount = (raw) => {
  if (raw === null || raw === undefined) return { status: "empty" };

  const text = String(raw).trim();
  if (text === "") return { status: "empty" };

  if (!AMOUNT_FORMAT.test(text)) return { status: "invalid" };

  const amount = Number(text);
  if (!Number.isFinite(amount) || amount <= 0) return { status: "invalid" };

  return { status: "ok", amount };
};
